import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getStates } from "../thunks/stateThunks";
import { StateResponse } from "../../types/states";

interface StateState {
  states: StateResponse[];
  state:StateResponse;
  loading: boolean;
  error: string | null;
  success: string | null;
}

const initialState: StateState = {
  states: [],
  state:null,
  loading: false,
  error: null,
  success: null,
};

export const stateSlice = createSlice({
  name: "state",
  initialState,
  reducers: {
    // optional manual setters if you still want to update state directly
    setStates: (state, action:PayloadAction<StateResponse[]>) => {
      state.states = action.payload;
    },
    setState: (state, action:PayloadAction<StateResponse>) => {
      state.state = action.payload;
    },
    setLoading: (state, action:PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action:PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStates.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(getStates.fulfilled, (state, action) => {
        state.loading = false;
        state.states = action.payload;
        state.success = "States loaded successfully";
      })
      .addCase(getStates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});

export const { setStates, setError,setState,setLoading } = stateSlice.actions;

export default stateSlice.reducer;

